// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import {
    BreakpointsFields,
    CurrentBpFieldCallback,
    FieldDefinitionBuilderFields,
    FieldDefinitionBuilderOptions,
} from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { css } from "styled-components";

const mergeFields = (fields: Dictionary<any>) => {
    return Object.keys(fields).reduce(
        (props, key) => ({
            ...props,
            [key]: fields[key],
        }),
        {},
    );
};

/**
 * A function that generates responsive css based by the given ResponsiveFields
 *
 * @param fields - The set of ResponsiveFields to implement the css on
 * @param currentBpFieldCallback - The callback executed on each breakpoint
 * @returns - The css for each breakpoint of the ResponsiveFields
 */
export const responsiveCss = <TFields extends FieldDefinitionBuilderOptions>(
    fields: (TFields & FieldDefinitionBuilderFields) | undefined,
    currentBpFieldCallback: CurrentBpFieldCallback,
) => {
    const fieldsByBreakpoint: BreakpointsFields[] = (fields?.responsive || []).map(({ fields }) => {
        return mergeFields(fields);
    });

    let baseField: BreakpointsFields = {};

    if (fields) {
        baseField = mergeFields(fields);
    }

    const breakpointsCss = [...fieldsByBreakpoint.map(currentBpFieldCallback)];

    return css`
        ${Object.keys(baseField).length ? currentBpFieldCallback(baseField) : null}
        ${({ theme }) =>
            fields?.useResponsiveOptions && breakpointMediaQueries(theme, breakpointsCss, mediaOptions.minMax)}
    `;
};
